@if (formControl()) {
<div class="autogroup form-group">
  <mat-form-field class="form-field">
    <input matInput [readonly]="$safeNavigationMigration(meta()?.readonly)" [placeholder]="$safeNavigationMigration(meta()?.name)" class="form-control input-date" [formControl]="formControl()!" [matAutocomplete]="auto" >
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onPick($event)">
      @for (group of filtered | async; track group.key) {
        <mat-optgroup [label]="group.key">
          @for (item of group.items; track item._id) {
            <mat-option [value]="item">
              {{item.name}}
            </mat-option>
          }
        </mat-optgroup>
      }
    </mat-autocomplete>
    <mat-hint><strong>{{meta()?.info}}</strong></mat-hint>
    @if (formControl()?.hasError('required')) {
      <mat-error>
        {{meta()?.name}} is <strong>required</strong>
      </mat-error>
    }
    @if (formControl()?.hasError('form')) {
      <mat-error>
        {{formError}}
      </mat-error>
    }
  </mat-form-field>
</div>
}
